<div class="documents-2 shadow white-bg">
   <h3
      *ngIf="
         !(
            this.professorsNumber == 0 &&
            professorName == undefined &&
            facultyId == '-1' &&
            departmentId == '-1' &&
            professorSubject == undefined
         )
      "
      class="filtersContainer"
   >
      <h4>{{ 'general.overview' | translate }}</h4>
      <div class="selectors">
         <div>
            <select [(ngModel)]="facultyId" (change)="selectedFaculty()">
               <option value="-1" selected disabled>
                  {{ 'app.filter_by_institution' | translate }}
               </option>
               <ng-container *ngFor="let faculty of this.faculties">
                  <option value="{{ faculty.id }}">{{ faculty.name }}</option>
               </ng-container>
               <option value="">{{ 'general.all' | translate }}</option>
            </select>
         </div>
         <div>
            <select
               disabled
               *ngIf="facultyId == '-1' || facultyId == ''"
               name=""
               id=""
            >
               <option>{{ 'general.select_institution_first' | translate }}</option>
            </select>
            <select
               *ngIf="facultyId !== '-1' && facultyId !== ''"
               [(ngModel)]="departmentId"
               (change)="selectedDepartment()"
            >
               <option value="-1" selected disabled>
                  {{ 'app.filter_by_department' | translate }}
               </option>
               <ng-container *ngFor="let department of this.departments">
                  <option value="{{ department.id }}">
                     {{ department.name }}
                  </option>
               </ng-container>
               <option value="">{{ 'general.all' | translate }}</option>
            </select>
         </div>
         <div>
            <input
               [placeholder]="'placeholders.search_by_subject' | translate"
               [(ngModel)]="professorSubject"
               (ngModelChange)="filterWithTimeout()"
               type="text"
               name="searchBySubject"
            />
         </div>
         <div>
            <input
               [placeholder]="'placeholders.search_by_name' | translate"
               [(ngModel)]="professorName"
               (ngModelChange)="filterWithTimeout()"
               type="text"
               name="searchByName"
            />
         </div>
         <button class="reportBtn" (click)="resetFilter()">{{ 'general.reset' | translate }}</button>
      </div>
   </h3>

   <div
      *ngIf="this.professorsNumber != 0"
      class="tableWithExpandedInfoAssignments"
   >
      <ng-container
         *ngFor="
            let professor of this.professors
               | paginate
                  : {
                       itemsPerPage: 5,
                       currentPage: this.page,
                       totalItems: this.professorsNumber
                    };
            let i = index
         "
      >
         <div>
            <div>
               <h4 class="blueText bold">
                  {{ professor.professorInfo.name }}
               </h4>
               <div>
                  <div>
                     <span>{{ 'app.institution' | translate }}</span>
                     <span>{{ 'general.department' | translate }}</span>
                     <span>{{ 'general.subjects' | translate }}</span>
                     <span>{{ 'general.assignments' | translate }}</span>
                     <span>{{ 'app.submissions_checked' | translate }}</span>
                     <span>{{ 'general.thesis' | translate }}</span>
                     <span>{{ 'general.avg_of_document_language' | translate }}</span>
                     <span>{{ 'general.avg_of_translated_language' | translate }}</span>
                  </div>
                  <div>
                     <span class="bold">{{ professor.faculty.name }}</span>
                     <span class="bold">{{ professor.department.name }}</span>
                     <span
                        (click)="subjectsFilter(professor.id)"
                        class="bold clickable"
                        >{{ professor.subjects }}</span
                     >
                     <span
                        (click)="assignmentFilter(professor.id)"
                        class="bold clickable"
                        >{{ professor.assignments }}</span
                     >
                     <span class="bold">{{
                        professor.submissionsChecked
                     }}</span>
                     <span
                        (click)="thesisFilter(professor.id)"
                        class="bold clickable"
                        >{{
                           professor.bachelor + professor.master + professor.phd
                        }}</span
                     >

                     <span class="bold">{{
                        professor.submissions._avg.originalPercentage?.toFixed(
                           2
                        ) || 0
                     }}</span>
                     <span class="bold">{{
                        professor.submissions._avg.translatedPercentage?.toFixed(
                           2
                        ) || 0
                     }}</span>
                  </div>
               </div>
               <a
                  *ngIf="expandInfo !== i"
                  class="blueText underline vold"
                  (click)="expand(i)"
                  >{{ 'general.expand' | translate }}</a
               >
               <a
                  *ngIf="expandInfo === i"
                  class="blueText underline vold"
                  (click)="expand(i)"
                  >{{ 'general.collapse' | translate }}</a
               >
            </div>
            <div
               [ngClass]="{ expandedInfo: expandInfo == i }"
               class="moreInfo"
               style="grid-template: none !important"
            >
               <div style="display: flex; justify-content: space-between">
                  <div style="grid-template: none">
                     <span>
                        {{ 'general.students' | translate }}:
                        <b>{{ professor.students }}</b></span
                     >
                     <span>
                        Assignments per month:
                        <b>{{ professor.avgAssignmentsMonth }}</b></span
                     >
                     <span>
                        Avg. Words per Assignment:
                        <b>{{
                           (
                              professor.submissions._avg.wordCount /
                              professor.assignments
                           ).toFixed(2)
                        }}</b>
                     </span>
                  </div>
                  <div style="grid-template: none">
                     <span>
                        Evaluation rate:
                        <b>{{ professor.evaluationRate }}%</b>
                     </span>
                     <!-- <span>
                         Average grade:
                         <b>75%</b>
                      </span> -->
                  </div>

                  <div style="grid-template: none">
                     <span>
                        Bachelor theses:
                        <b>{{ professor.bachelor }}</b></span
                     >
                     <span>
                        Master theses:
                        <b>{{ professor.master }}</b></span
                     >
                     <span>
                        Ph.D theses:
                        <b>{{ professor.phd }}</b></span
                     >
                  </div>

                  <div style="grid-template: none">
                     <span>
                        {{ 'report.high_similarity_submissions' | translate }}:
                        <b>{{ professor.highSimilarity }}</b></span
                     >
                     <span>
                        {{ 'report.medium_similarity_submissions' | translate }}:
                        <b>{{ professor.mediumSimilarity }}</b></span
                     >
                     <span>
                        {{ 'report.low_similarity_submissions' | translate }}:
                        <b>{{ professor.lowSimilarity }}</b></span
                     >
                  </div>
               </div>
            </div>
         </div>
      </ng-container>
   </div>
   <div
      class="zeroState"
      *ngIf="
         this.professorsNumber == 0 &&
         (professorName != undefined ||
            facultyId != '-1' ||
            departmentId != '-1' ||
            professorSubject != undefined)
      "
   >
      No users found
   </div>
   <pagination-controls
      *ngIf="this.professorsNumber != 0"
      class="num"
      (pageChange)="changePage($event)"
      responsive="true"
      previousLabel=""
      nextLabel=""
   ></pagination-controls>
   <div
      class="zero-state"
      *ngIf="
         this.professorsNumber == 0 &&
         professorName == undefined &&
         facultyId == '-1' &&
         departmentId == '-1' &&
         professorSubject == undefined
      "
   >
      <!-- <img src="../../assets/images/icona-image.png" alt="" /> -->
      <h5 class="bold">{{ 'app.there_are_no_educators_registered_in_your_instutition' | translate }}.</h5>
   </div>
</div>
